export const blockIconsSocialRocketLaunchNew = (
	<span className='material-symbols-outlined'>rocket_launch</span>
);
